<template>
  <section class="prospection-sequence">
    <h6 class="prospection-sequence__section-title">
      <i class="icon icon-search" aria-hidden="true"></i>
      {{ $t('lang.label.admin_panel_sequence_section') }}
    </h6>

    <div class="prospection-sequence__card">
      <div class="prospection-sequence__business-row">
        <h6 class="prospection-sequence__business-name">{{ business.name }}</h6>
        <button
          type="button"
          class="prospection-sequence__copy-btn"
          :title="$t('lang.general.copytoclipboard') + ': Link'"
          @click="copyUrl(getAdminTaskLink())"
        >
          <i class="icon icon-clipboard" aria-hidden="true"></i>
        </button>
      </div>

      <!-- <span
        class="prospection-sequence__campaign-badge"
        :class="statusBadgeOliver(status.name)"
      >{{ link.campaign_name }}</span> -->

      <!-- <div class="prospection-sequence__tags">
        <multiselect
          v-model="value"
          tag-placeholder="Add this as new tag"
          v-bind:placeholder="$t('lang.label.searchoraddatag')"
          label="name"
          track-by="id"
          :options="options"
          :multiple="true"
          :taggable="true"
          :searchable="true"
          :showLabels="false"
          openDirection="below"
          class="prospection-sequence__multiselect small"
          @tag="addTag($event)"
          @input="onChange($event)"
          @select="selectLinkTag($event)"
          @remove="removeLinkTag($event)"
        >
          <template slot="option" slot-scope="props">
            <span class="option__title customOptions">
              <div style="font-size: 1rem">{{ props.option.name }}</div>
              <div>
                <a
                  v-if="props.option.client_id != undefined"
                  @mouseover="hover = true"
                  @mouseleave="hover = false"
                  @click="removeTag(props.option)"
                >
                  <span class="icon-remove ft-2" />
                </a>
              </div>
            </span>
          </template>

          <template slot="tag" slot-scope="props">
            <span
              class="multiselect__tag"
              v-bind:style="'background: #' + props.option.color"
            >
              <span v-text="props.option.name" class="mr-1"></span>
              <i
                aria-hidden="true"
                tabindex="1"
                @keydown.enter.prevent="removeLinkTag(props.option)"
                @mousedown.prevent="removeLinkTag(props.option)"
                class="multiselect__tag-icon"
                v-bind:style="'background: #' + props.option.color"
              ></i>
            </span>
          </template>
        </multiselect>
      </div> -->

      <div class="prospection-sequence__status-row">
        <span
          class="prospection-sequence__status-dot"
          :class="isSequenceActive ? 'prospection-sequence__status-dot--active' : 'prospection-sequence__status-dot--inactive'"
        ></span>
        <span class="prospection-sequence__status-text">
          {{ isSequenceActive ? $t('lang.label.admin_panel_sequence_active') : $t('lang.label.admin_panel_sequence_inactive') }}
        </span>

        <div class="prospection-sequence__menu-wrap" v-click-outside="closeMenu">
          <button
            type="button"
            class="prospection-sequence__menu-btn"
            :aria-label="$t('lang.label.admin_panel_sequence_menu_aria')"
            @click="toggleMenu"
          >
            <i class="icon icon-ellipsis-v" aria-hidden="true"></i>
          </button>

          <div v-if="menuOpen" class="prospection-sequence__dropdown">
            <template v-if="isSequenceActive">
              <button
                type="button"
                class="prospection-sequence__dropdown-item prospection-sequence__dropdown-item--danger"
                @click="onCancelRelances"
              >
                <i class="icon icon-stop-circle-o" aria-hidden="true"></i>
                <span>
                  <strong>{{ $t('lang.label.admin_panel_cancel_relances') }}</strong>
                  <small>{{ $t('lang.label.admin_panel_cancel_relances_desc') }}</small>
                </span>
              </button>
            </template>
            <template v-else>
              <button
                type="button"
                class="prospection-sequence__dropdown-item"
                @click="onReengageImmediate"
              >
                <i class="icon icon-refresh" aria-hidden="true"></i>
                <span>
                  <strong>{{ $t('lang.label.admin_panel_reengage_sequence') }}</strong>
                  <small>{{ $t('lang.label.admin_panel_reengage_sequence_desc') }}</small>
                </span>
              </button>
              <button
                type="button"
                class="prospection-sequence__dropdown-item"
                @click="onReengage30Days"
              >
                <i class="icon icon-calendar-times-o" aria-hidden="true"></i>
                <span>
                  <strong>{{ $t('lang.label.admin_panel_reengage_30_days') }}</strong>
                  <small>{{ $t('lang.label.admin_panel_reengage_30_days_desc') }}</small>
                </span>
              </button>
            </template>
          </div>
        </div>
      </div>

      <ActionButtonsDisqualified
        ref="disqualifiedActions"
        v-if="status.name === 'Positive'"
        :link="{ id: link.id }"
        :status="'define status'"
        :suppress-buttons="true"
      />
    </div>
  </section>
</template>

<script>
import { opportunitiesService } from "@/_services";
import {
  statusButtonMixin,
  statusBadgeMixin,
  urlMixin,
  logoMixin,
} from "@/_mixins";
import { mapActions, mapState } from "vuex";
import ActionButtonsDisqualified from "@/components/Emails/ActionButtonsDisqualified.vue";
import Multiselect from "vue-multiselect";
import { tagsService } from "@/_services";

export default {
  name: "OportunityTopArea",
  directives: {
    clickOutside: {
      bind(el, binding) {
        el._clickOutside = (event) => {
          if (!el.contains(event.target)) {
            binding.value(event);
          }
        };
        document.addEventListener("click", el._clickOutside);
      },
      unbind(el) {
        document.removeEventListener("click", el._clickOutside);
      },
    },
  },
  data() {
    return {
      menuOpen: false,
      value: [],
      options: [],
      hover: false,
      deleted: "",
    };
  },
  mixins: [statusButtonMixin, statusBadgeMixin, urlMixin, logoMixin],
  components: {
    Multiselect,
    ActionButtonsDisqualified,
  },
  props: {
    business: Object,
    status: Object,
    businessContacts: Array,
    link: Object,
    unlocked: Number,
    events: Array,
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.authentication.user,
    }),
    isSequenceActive() {
      return this.status.name !== "Positive";
    },
  },
  created() {
    document.title = this.business.name;
    this.getAllTags();
  },
  mounted() {
    this.getAllByLinkId();
  },
  methods: {
    ...mapActions("opportunities", {
      addOpportunityTag: "addOpportunityTag",
      removeOpportunityTag: "removeOpportunityTag",
    }),
    toggleMenu() {
      this.menuOpen = !this.menuOpen;
    },
    closeMenu() {
      this.menuOpen = false;
    },
    onCancelRelances() {
      this.closeMenu();
      this.executeAction("positiveBusiness");
    },
    onReengage30Days() {
      this.closeMenu();
      const ref = this.$refs.disqualifiedActions;
      if (ref) {
        ref.disqualifiedOpportunity(30);
      }
    },
    onReengageImmediate() {
      this.closeMenu();
      const ref = this.$refs.disqualifiedActions;
      if (ref) {
        ref.openModal("DISQUALIFIED");
      }
    },
    copyUrl(link) {
      if (this.copyToClipboard(link)) {
        this.$swal({
          type: "success",
          title: this.$t("lang.label.great"),
          text: this.$t("lang.general.copiedtoclipboard"),
          showConfirmButton: false,
          timer: 1500,
        });
      }
    },
    copyToClipboard(text) {
      if (window.clipboardData && window.clipboardData.setData) {
        return window.clipboardData.setData("Text", text);
      } else if (
        document.queryCommandSupported &&
        document.queryCommandSupported("copy")
      ) {
        var textarea = document.createElement("textarea");
        textarea.textContent = text;
        textarea.style.position = "fixed";
        document.body.appendChild(textarea);
        textarea.select();
        try {
          return document.execCommand("copy");
        } catch (ex) {
          console.warn("Copy to clipboard failed.", ex);
          return prompt("Copy to clipboard: Ctrl+C, Enter", text);
        } finally {
          document.body.removeChild(textarea);
        }
      }
    },
    getAdminTaskLink() {
      const location = window.location;
      const baseUrl = `${location.protocol}//${location.host}`;
      return `${baseUrl}/admin-tasks`;
    },
    addTag(newTag) {
      const tag = {
        name: newTag,
        description: newTag,
        color: this.getRandomColor(),
        tag_type_id: 1,
      };
      tagsService.createTag(tag).then((tag) => {
        tagsService.createLinkTag(this.link.id, tag.id).then(() => {
          this.getAllTags();
          this.value.push(tag);
          this.addOpportunityTag({ link_id: this.link.id, tag: tag });
        });
      });
    },
    onChange(value) {
      if (this.hover == true) {
        if (value != undefined && value.length > 0) {
          this.value = value.filter((t) => t.id != this.deleted.id);
        }
      }
    },
    selectLinkTag(tag) {
      if (this.hover == false) {
        tagsService.createLinkTag(this.link.id, tag.id);
        this.addOpportunityTag({ link_id: this.link.id, tag: tag });
      }
    },
    removeLinkTag(tag) {
      let tag_id = 0;
      if (tag.tag_id !== undefined) {
        tag_id = tag.tag_id;
      } else {
        tag_id = tag.id;
      }

      tagsService.removeLinkTag(this.link.id, tag_id).then(() => {
        if (this.value != undefined && this.value.length > 0) {
          this.value = this.value.filter((t) => t.id != tag.id);
        }
        this.removeOpportunityTag({ link_id: this.link.id, tag: tag });
      });
    },
    removeTag(tag) {
      this.deleted = tag;
      tagsService.removeTag(tag.id).then(() => {
        this.options = this.options.filter((t) => t.id != this.deleted.id);
      });
    },
    getRandomColor() {
      var r, g, b, rg, gb, rb;
      var range = 180;
      var sep = range / 4;
      do {
        r = Math.floor(Math.random() * range);
        g = Math.floor(Math.random() * range);
        b = Math.floor(Math.random() * range);
        rg = Math.abs(r - g);
        gb = Math.abs(g - b);
        rb = Math.abs(r - b);
      } while (rg < sep || gb < sep || rb < sep);

      function rgbtohex(rgb) {
        var first, second;
        first = Math.floor(rgb / 16);
        second = rgb % 16;
        first = first.toString(16);
        second = second.toString(16);
        return first + second;
      }

      var r_str = rgbtohex(r),
        g_str = rgbtohex(g),
        b_str = rgbtohex(b);
      return r_str + g_str + b_str;
    },
    executeAction(action) {
      this.$emit(action, {
        linkId: this.link.id,
        statusReason: "24",
      });
    },
    getAllByLinkId() {
      tagsService.getAllByLinkId(this.link.id).then((tags) => {
        if (tags.length > 0) {
          for (let i = 0; i < tags.length; i++) {
            this.value.push({
              id: tags[i].id,
              name: tags[i].tag_name,
              description: tags[i].description,
              client_id: null,
              color: tags[i].color,
              tag_id: tags[i].tag_id,
            });
          }
        }
      });
    },
    getAllTags() {
      tagsService.getAllByClientId().then((tags) => {
        this.options = tags;
      });
    },
  },
};
</script>

<style scoped>
.prospection-sequence {
  --ol-brand: #5054eb;
  padding: 1rem;
  border-bottom: 1px solid #f3f4f6;
}

.prospection-sequence__section-title {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.03em;
  color: #6b7280;
  margin: 0 0 0.75rem;
  text-transform: uppercase;
}

.prospection-sequence__section-title i {
  color: var(--ol-brand);
}

.prospection-sequence__card {
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 1rem;
  background: #ffffff;
}

.prospection-sequence__business-row {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
}

.prospection-sequence__business-name {
  flex: 1;
  font-size: 0.85rem;
  font-weight: 700;
  color: #111827;
  margin: 0;
  text-transform: uppercase;
  line-height: 1.3;
}

.prospection-sequence__copy-btn {
  flex-shrink: 0;
  background: none;
  border: none;
  padding: 0.15rem;
  color: #9ca3af;
  cursor: pointer;
  line-height: 1;
}

.prospection-sequence__copy-btn:hover {
  color: var(--ol-brand);
}

.prospection-sequence__campaign-badge {
  display: inline-block;
  font-size: 0.72rem;
  font-weight: 500;
  padding: 0.2rem 0.55rem;
  border-radius: 999px;
  margin-bottom: 0.75rem;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.prospection-sequence__tags {
  margin-bottom: 0.75rem;
}

.prospection-sequence__status-row {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.6rem 0.75rem;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
}

.prospection-sequence__status-dot {
  flex-shrink: 0;
  width: 8px;
  height: 8px;
  border-radius: 50%;
}

.prospection-sequence__status-dot--active {
  background: #22c55e;
}

.prospection-sequence__status-dot--inactive {
  background: #9ca3af;
}

.prospection-sequence__status-text {
  flex: 1;
  font-size: 0.8rem;
  font-weight: 500;
  color: #374151;
}

.prospection-sequence__menu-wrap {
  position: relative;
  flex-shrink: 0;
}

.prospection-sequence__menu-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  color: #6b7280;
  cursor: pointer;
}

.prospection-sequence__menu-btn:hover {
  background: #f3f4f6;
}

.prospection-sequence__dropdown {
  position: absolute;
  top: calc(100% + 4px);
  right: 0;
  z-index: 20;
  min-width: 260px;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  padding: 0.35rem;
}

.prospection-sequence__dropdown-item {
  display: flex;
  align-items: flex-start;
  gap: 0.65rem;
  width: 100%;
  padding: 0.6rem 0.65rem;
  text-align: left;
  background: none;
  border: none;
  border-radius: 8px;
  cursor: pointer;
}

.prospection-sequence__dropdown-item:hover {
  background: #f9fafb;
}

.prospection-sequence__dropdown-item i {
  flex-shrink: 0;
  font-size: 1rem;
  margin-top: 0.1rem;
  color: #6b7280;
}

.prospection-sequence__dropdown-item span {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.prospection-sequence__dropdown-item strong {
  font-size: 0.82rem;
  color: #111827;
  font-weight: 600;
}

.prospection-sequence__dropdown-item small {
  font-size: 0.72rem;
  color: #9ca3af;
  margin-top: 0.1rem;
}

.prospection-sequence__dropdown-item--danger strong,
.prospection-sequence__dropdown-item--danger i {
  color: #dc2626;
}

.prospection-sequence__dropdown-item--danger small {
  color: #f87171;
}

</style>

<style>
.prospection-sequence__multiselect .multiselect__tags {
  background: #ffffff;
  border-color: #d1d5db;
  border-radius: 8px;
  min-height: 38px;
}

.prospection-sequence__multiselect .multiselect__input,
.prospection-sequence__multiselect .multiselect__single {
  background: transparent;
  color: #111827;
  font-size: 0.85rem;
}
</style>

